<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px"
             class="demo-ruleForm">
      <div style="display:flex;margin-top:40px">
        <div class="left" style="width:600px;">
          <el-form-item label="直播标题:"
                        prop="title">
            <el-input v-model="ruleForm.title"
                      placeholder="必填，2-40个字"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间:"
                        prop="startAt">
                <el-date-picker type="datetime"
                                :clearable="false"
                                :picker-options="pickerOptionsStart"
                                placeholder="选择日期"
                                v-model="ruleForm.startAt"
                                style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="截止时间:"
                        prop="endAt">
                <el-date-picker type="datetime"
                                :clearable="false"
                                :picker-options="pickerOptionsEnd"
                                placeholder="选择日期"
                                v-model="ruleForm.endAt"
                                style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="26">
              <el-form-item label="谁能编辑:"
                        prop="appointUidsType">
                <el-radio-group v-model="ruleForm.appointUidsType"
                                size="mini"
                                :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'">
                  <el-radio label="2">指定人</el-radio>
                  <el-radio label="1">创建人</el-radio>
                  <el-radio label="0">所有人</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="ruleForm.appointUidsType === '2'"
                  style="margin-bottom:10px;"
                  :gutter="20">
              <el-form-item label="指定用户:" prop="appointUidsName">
                <el-col :span="6">
                  <el-button @click="openDialog">选择用户</el-button>
                </el-col>
                <el-col :span="14">
                  <el-input disabled
                          v-model="ruleForm.appointUidsName"
                          :title="ruleForm.appointUidsName"
                          placeholder="请选择用户"></el-input>
                </el-col>
                
              </el-form-item>

          </el-row>
          
          
          <el-form-item label="封面图:"
                        prop="appointUidsType">
            <div style="display:flex;">
              <div style="text-align:left;margin-right:7%;">
                  <el-upload class="upload-demo"
                          action="#"
                          :show-file-list="false"
                          :auto-upload="false"
                          :on-change="onChange">
                    <div v-if="!thumbnailFile && !isFile"
                        style="width:120px;height:80px;background: rgba(0, 0, 0, 0.02);
                          border: 1px dashed rgba(0, 0, 0, 0.15);display:flex;align-items: center;justify-content: center;">
                      <img src="@/assets/uploader/add.png" width="15px" alt="">
                    </div>
                    <div v-if="isFile"
                        style="width:80px;height:80px;background: rgba(0, 0, 0, 0.02);
                          border: 1px dashed rgba(0, 0, 0, 0.15);display:flex;align-items: center;justify-content: center;">
                      <i class="el-icon-loading"></i>
                    </div>
                  </el-upload>
                  
                  <div v-if="thumbnailFile"
                    class="imgbj">
                    <el-image class="imgs"
                              :src="thumbnailFile.src"
                              :preview-src-list="[thumbnailFile.src]"></el-image>
                    <p @click.stop="deleteThumbnailFile"
                      :style="{'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                      class="delete">删除</p>
                  </div>
                  <div class="msg">
                    pc端：建议大小为1200*660像素
                  </div>
              </div>

              <div style="text-align:left">
                  <el-upload class="upload-demoMo"
                          action="#"
                          :show-file-list="false"
                          :auto-upload="false"
                          :on-change="onChangeMo">
                    <div v-if="!thumbnailFileMo && !isFileMo"
                        style="width:120px;height:80px;background: rgba(0, 0, 0, 0.02);
                          border: 1px dashed rgba(0, 0, 0, 0.15);display:flex;align-items: center;justify-content: center;">
                      <img src="@/assets/uploader/add.png" width="15px" alt="">
                    </div>
                    <div v-if="isFileMo"
                        style="width:80px;height:80px;background: rgba(0, 0, 0, 0.02);
                          border: 1px dashed rgba(0, 0, 0, 0.15);display:flex;align-items: center;justify-content: center;">
                      <i class="el-icon-loading"></i>
                    </div>
                  </el-upload>
                  
                  <div v-if="thumbnailFileMo"
                    class="imgbj">
                    <el-image class="imgs"
                              style="left:230px;"
                              :src="thumbnailFileMo.src"
                              :preview-src-list="[thumbnailFileMo.src]"></el-image>
                    <p @click.stop="deleteThumbnailFileMo"
                      :style="{'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3','left':'330px'}"
                      class="delete">删除</p>
                  </div>
                  <div class="msg">
                    移动端：建议大小为900*675像素
                  </div>
              </div>
            </div>
          </el-form-item>
          
        </div>
        <div class="right" style="width:600px;">
          <el-form-item label="直播详情:"
                    prop="desc">
            <el-input
              type="textarea"
              :autosize="{ minRows: 16, maxRows: 20}"
              placeholder="请输入内容"
              v-model="ruleForm.desc">
            </el-input>
            <!-- <div id="websiteEditorElem"
                style="height:400px;width:600px;background: #ffffff;"></div> -->
          </el-form-item>
        </div>
      </div>

      

    </el-form>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>


    <el-dialog :visible.sync="dialogVisible"
               width="32%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>选择用户</div>
      </div>
      <div>
        <el-transfer v-model="transferValue"
                     :titles="['所有用户', '已选择用户']"
                     :data="transferData"
                     :left-default-checked="[]"></el-transfer>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="chooseUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addQuillTitle } from "@/plugins/quill-title.js";
import { getDate, formatConversion } from "@/plugins/getdate";
import { listUser, getUser } from "@/api/user";
// import { mapGetters } from "vuex";
import E from "wangeditor";
import { picPrefix } from "@/constants/piccommon";
import getMD5 from "@/plugins/getMD5";
import SparkMD5 from "spark-md5";
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
export default {
  props: {
    ruleForm: Object,
    draftactivityName: String
  },
  // computed: {
  //   ...mapGetters(["createUid"])
  // },
  data () {
    return {
      //选择用户
      dialogVisible: false,
      transferData: [],
      transferValue: [],

      //判断背景图是不是在上传
      isFile: false,
      isFileMo: false,
      isUpdata: false,
      picPrefix,
      thumbnailFile: null,
      thumbnailFileMo: null,

      phoneEditor: "",
      rules: {
        title: [
          { required: true, message: "请输入直播标题", trigger: "blur" },
          { min: 2, max: 40, message: "长度在 2 到 40 个字符", trigger: "blur" }
        ],
        appointUidsName: [
          { required: true, message: "请选择指定用户", trigger: "change" }
        ],
        startAt: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],

        endAt: [{ required: true, message: "请选择截止时间", trigger: "blur" }],

        appointUidsType: [
          {
            required: true,
            message: "请至少选择一个选项",
            trigger: "change"
          }
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur"
          },
          { required: true, message: "请输入直播详情", trigger: "blur" }
        ]
      },
      content: ``,

      pickerOptionsEnd: {
        disabledDate: time => {
          return this.ruleForm.startAt ? time < this.ruleForm.startAt : "";
        }
      },

      pickerOptionsStart: {
        disabledDate: time => {
          return this.ruleForm.endAt ? time > this.ruleForm.endAt : "";
        }
      },

      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], //不需要设置值，直接写名字
              [{ header: 1 }, { header: 2 }], //需要设置值
              [{ script: "sub" }, { script: "super" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              ["image"] //上传图片
            ]
          }
        }
      }
    };
  },
  methods: {

    handleClose () {
      this.dialogVisible = false;
      // this.transferValue = [];
      this.transferData = [];
      this.listUserAsync();
    },

    openDialog () {
      if (typeof this.ruleForm.appointUids === "string") {
        let aUI = [];
        for (
          let i = 0;
          i < this.ruleForm.appointUids.split(",").length;
          i++
        ) {
          aUI.push(parseInt(this.ruleForm.appointUids.split(",")[i]));
        }
        this.transferValue = aUI;
      } else if (this.ruleForm.appointUids instanceof Array) {
        let aUI = [];
        for (let i = 0; i < this.ruleForm.appointUids.length; i++) {
          aUI.push(parseInt(this.ruleForm.appointUids[i]));
        }
        this.transferValue = aUI;
      }

      setTimeout(() => {
        this.dialogVisible = true;
      }, 300);
    },

    //确认选中的用户
    chooseUser () {
      this.ruleForm.appointUids = "";
      this.ruleForm.appointUidsName = "";

      if (isNaN(this.transferValue[0])) {
        this.transferValue.shift();
      }

      for (let i = 0; i < this.transferValue.length; i++) {
        this.getUserAsync(this.transferValue[i]);
      }
      this.ruleForm.appointUids = this.transferValue;
      setTimeout(() => {
        this.dialogVisible = false;
      }, 1000);
    },
    //查询用户
    async getUserAsync (val) {
      let { status, data, message, errors } = await getUser(val);
      if (status) {
        this.ruleForm.appointUidsName += data.name + ";";
        // console.log(this.ruleForm.appointUidsName)
      }
    },
    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].userType !== 1) {
            this.transferData.push({
              key: data[i].id,
              label: data[i].name
            });
          }

        }
      }
    },



    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.thumbnailFile === null) {
            this.$message.warning("请上传网站版主题图！");
          } else if (this.thumbnailFileMo === null) {
            this.$message.warning("请上传手机版主题图！");
          } else {
            this.ruleForm.pcIndexpic = this.thumbnailFile.themePicture;
            this.ruleForm.mobileIndexpic = this.thumbnailFileMo.themePicture;
            switch (this.ruleForm.appointUidsType) {
              case '0':
                this.ruleForm.appointUids = '0'
                break;
              case '1':
                this.ruleForm.appointUids = this.ruleForm.createUid
                break;
              case '2':
                this.ruleForm.appointUids = this.ruleForm.appointUids.join(",");
                break;
              default:
                this.ruleForm.appointUids = '0'
                break;
            }

            let start = new Date(this.ruleForm.startAt)
            let end = new Date(this.ruleForm.endAt)

            this.ruleForm.startAt = start.getTime(start) / 1000
            this.ruleForm.endAt = end.getTime(end) / 1000

            if (this.isUpdata) {
              this.$emit("updataForm", this.ruleForm);
            } else {
              this.$emit("submitForm", this.ruleForm);
            }

          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$emit("closeForm");
    },

    deleteThumbnailFile () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        customClass: 'messageBox-prompt-test'
      })
        .then(e => {
          this.thumbnailFile = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },
    deleteThumbnailFileMo () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        customClass: 'messageBox-prompt-test'
      })
        .then(e => {
          this.thumbnailFileMo = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },

    onChange (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 20;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)
      this.isFile = true

      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      if (file.raw.size > 560000) {
        bytesPerPiece = 202020;
      } else {
        bytesPerPiece = 9888;
      }

      let fd = new FormData();
      fd.append("file", file.raw);
      getMD5(file.raw, md5 => {
        this.getFileInfoByHashAsync(
          md5,
          file.raw,
          bytesPerPiece,
          totalPieces,
          1
        );
      });
      // this.uploadPicAsync(fd, 1);
    },

    onChangeMo (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 20;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)
      this.isFileMo = true

      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      if (file.raw.size > 560000) {
        bytesPerPiece = 202020;
      } else {
        bytesPerPiece = 9888;
      }

      let fd = new FormData();
      fd.append("file", file.raw);
      getMD5(file.raw, md5 => {
        this.getFileInfoByHashAsyncMo(
          md5,
          file.raw,
          bytesPerPiece,
          totalPieces,
          1
        );
      });
      // this.uploadPicAsync(fd, 1);
    },

    //分片上传
    fragmentationMo (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsyncMo(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsyncMo(params, blob, insert);
        }
        start = end;
        index++;
      }
    },
    //分片上传
    fragmentation (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsync(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsync(params, blob, insert);
        }
        start = end;
        index++;
      }
    },

    //常规文件上传
    async uploadPicAsyncMo (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFileMo = val;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsyncMo (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsyncMo(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsyncMo (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsyncMo(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFileMo = blob;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        }
      }
    },

    //常规文件上传
    async uploadPicAsync (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFile = val;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsyncMo (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentationMo(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFileMo = blob;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        }

      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentation(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }

      }
    },


    // // 设置保存发送后台数据事件
    // submit() {
    //   var data = new FormData();
    //   data.append("cotent", this.phoneEditor.txt.html());
    //   this.$axios({
    //     methods: "post",
    //     url: "后台给的地址",
    //     data: data,
    //     headers: {
    //       token: window.localStorage["token"]
    //     }
    //   })
    //     .then(res => {
    //       if (res.status === 200) {
    //         console.log("success!");
    //       }
    //     })
    //     .catch(res => {
    //       console.log(res);
    //     });
    // }
  },
  created () {
    this.listUserAsync({ pageSize: 10000 });
    // console.log(this.ruleForm.startAt)
    if (this.ruleForm.pcIndexpic !== "") {
      this.thumbnailFile = {
        src: picPrefix + this.ruleForm.pcIndexpic
      }
    }
    if (this.ruleForm.mobileIndexpic !== "") {
      this.thumbnailFileMo = {
        src: picPrefix + this.ruleForm.mobileIndexpic
      }
    }

    if (this.ruleForm.title) {
      this.isUpdata = true
    }

    if(this.ruleForm.appointUids.length > 0){
      this.ruleForm.appointUidsType = '2'
      for (let i = 0; i < this.ruleForm.appointUids.length; i++) {
        this.getUserAsync(this.ruleForm.appointUids[i]);
      }
    }
    

    if(this.ruleForm.appointUids == '0'){
      this.ruleForm.appointUidsType = '0'
      this.ruleForm.appointUids = ''
    }
    if(this.ruleForm.appointUids == this.ruleForm.createUid){
      this.ruleForm.appointUidsType = '1'
      this.ruleForm.appointUids = ''
    }


    this.ruleForm.startAt = this.ruleForm.startAt ? new Date(this.ruleForm.startAt*1000) : this.ruleForm.startAt
    this.ruleForm.endAt = this.ruleForm.endAt ? new Date(this.ruleForm.endAt*1000) : this.ruleForm.endAt
    // this.ruleForm.startAt = formatConversion(this.ruleForm.startAt.toString(), 'havaTime')
    // this.ruleForm.endAt = formatConversion(this.ruleForm.endAt.toString(), 'havaTime')
  },
  mounted () {

    var that = this;
    this.phoneEditor = new E("#websiteEditorElem");
    // 上传图片到服务器，base64形式
    // this.phoneEditor.customConfig.uploadImgShowBase64 = true;
    // 隐藏网络图片
    this.phoneEditor.customConfig.showLinkImg = false;

    // 配置服务器端地址
    // this.phoneEditor.customConfig.uploadImgServer = 'https://httpbin.org/post'

    // 自定义菜单配置
    this.phoneEditor.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // 'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      // 'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 将图片大小限制为 50M
    this.phoneEditor.customConfig.uploadImgMaxSize = 50 * 1024 * 1024;

    // 限制一次最多上传 10 张图片
    this.phoneEditor.customConfig.uploadImgMaxLength = 10;

    //上传图片事件
    this.phoneEditor.customConfig.customUploadImg = function (files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
      that.phoneEditor.txt.html(that.phoneEditor.txt.html() + icon)

      files.forEach(item => {
        // var reader = new FileReader();
        // reader.readAsDataURL(item);
        // reader.onload = function(e) {
        //   insert(this.result);
        // };

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item, md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        });

        // that.$nextTick(() => {
        //   that.phoneEditor.txt.html('')
        // });
      });

      // files.forEach(item => {
      //   that.$nextTick(()=>{
      //     let fd = new FormData();
      //     fd.append("file", item); // 上传的文件： 键名，键值
      //     axios.post("https://jsonplaceholder.typicode.com/posts/",{file:fd}
      //    )
      //     .then(res => {
      //       console.log(res)
      //     })
      //     .catch(res => {
      //       console.log(res);
      //     });
      //   })

      // 以下是上传图片的接口，视情况而更改就可以啦
      // 上传地址的接口名(fd).then(data => {
      //   // 上传代码返回结果之后，将图片插入到编辑器中
      //   insert(data.url);
      // });
      // });
    };

    // this.phoneEditor.customConfig.uploadImgHooks = {
    //   before: function (xhr, editor, files) {
    //       // 图片上传之前触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

    //       console.log(files)

    //       // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
    //       // return {
    //       //     prevent: true,
    //       //     msg: '放弃上传'
    //       // }
    //   },
    //   success: function (xhr, editor, result) {
    //       // 图片上传并返回结果，图片插入成功之后触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    //   },
    //   fail: function (xhr, editor, result) {
    //       // 图片上传并返回结果，但图片插入错误时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    //   },
    //   error: function (xhr, editor) {
    //       // 图片上传出错时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    //   },
    //   timeout: function (xhr, editor) {
    //       // 图片上传超时时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    //   },

    //   // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
    //   // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
    //   customInsert: function (insertImg, result, editor) {
    //       // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
    //       // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

    //       // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
    //       var url = result.files['image.png']
    //       insertImg(url)

    //       // result 必须是一个 JSON 格式字符串！！！否则报错
    //   }
    // }

    // 创建一个富文本编辑器
    this.phoneEditor.create();
    // 富文本内容
    this.phoneEditor.txt.html(this.ruleForm.content);
  }
};
</script>

<style lang="scss" scoped>
.quill-editor /deep/ .ql-container {
  height: 240px !important;
}

#websiteEditorElem /deep/ .w-e-text-container {
  z-index: 3 !important;
}
#websiteEditorElem /deep/ .w-e-menu {
  z-index: 5 !important;
}
// #websiteEditorElem /deep/ .w-e-text-container,
// #websiteEditorElem /deep/ .w-e-toolbar
// {
//   z-index: 1999 !important;
// }

// .el-form /deep/ .el-input-number__decrease,
// .el-form /deep/ .el-input-number__increase{
//   z-index: 0.5 !important;
// }

.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  z-index: 7;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
// .bottombtn /deep/ .el-button--primary {
//   background-color: #185ed3;
// }
/deep/ .el-form-item__label {
  font-weight: 600;
}
.imgbj {
  // &:hover .delete {
  //   opacity: 1;
  // }
  height: 40px;
  .imgs {
    width: 80px;
    height: 80px;
    position: absolute;
    top: -10px;
    left: 5px;
  }

  .delete {
    position: absolute;
    top: 45px;
    left: 95px;
    transform: 0.5s;
    opacity: 1;
    color: #185ed3;
    cursor: pointer;
  }
}

/deep/ .el-icon-circle-close {
  margin-top: 150px;
}
.msg {
  // position: absolute;
  // right: 0;
  // top: 0;
  color:#CCCCCC;
  font-size: 13px;
}

/deep/ .el-image-viewer__wrapper {
  z-index: 10003 !important;
}
.gjzw /deep/ .el-form-item__label {
  line-height: 45px;
  padding-right: 18px;
  // box-sizing: border-box;
}
// .tpbz /deep/ .el-form-item__label {
//   padding-right: 18px;
//   line-height: 45px;
// }
/deep/ .el-input-number--small {
  width: 105px;
}
</style>
